import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import SettingsIcon from "@mui/icons-material/Settings";
import { NavItem } from "src/app/components/Dashboard/types";
import { RoutingPath } from "src/features/routing/types";

const navItems: NavItem[] = [
  {
    label: "מבט על",
    icon: <DashboardIcon />,
    path: RoutingPath.Overview,
  },
  {
    label: "העדרויות",
    icon: <PersonOffIcon />,
    path: RoutingPath.Missings,
  },
  {
    label: "הגדרות",
    icon: <SettingsIcon />,
    path: RoutingPath.Settings,
  },
];

export default navItems;
